import { defineMessages } from 'react-intl'

export default defineMessages({
  thisWeekendEvents: {
    id: 'home.this-weekend-events',
    defaultMessage: 'Happening this weekend',
  },
  trendingEvents: {
    id: 'home.trending-events',
    defaultMessage: 'Trending events',
  },
  freeEvents: {
    id: 'home.free-events',
    defaultMessage: 'Free events',
  },
  eventsInCity: {
    id: 'home.events-in-city',
    defaultMessage: 'Events in ',
  },
  eventsNearCity: {
    id: 'home.events-near-city',
    defaultMessage: 'Events near ',
  },
  exploreCategories: {
    id: 'home.explore-categories',
    defaultMessage: 'Explore events by category',
  },
  exploreCategoriesInCity: {
    id: 'home.explore-categories-in-city',
    defaultMessage: 'Explore events in {cityName} by category',
  },
  organizersTitle: {
    id: 'home.organizers-title',
    defaultMessage: 'You’re in good company',
  },
  organizersCount: {
    id: 'home.organizers-count',
    defaultMessage: 'Over 50,000 event organizers choose Universe',
  },
})
